$(function() {

	$("#next-page-button").ajaxNextEshopPage({
		"containerId": "refresh-target",
		"buttonId": "next-page-button",
		"alsoRefresh": ["#paginator-bottom","#paginator-top","#next-page-button"],
		"loadingClass": "now-loading",
		"success": function() {
			var scrollPosition = $(window).scrollTop();
			//window.location = "#refresh-target";
			$(window).scrollTop(scrollPosition);
			var countR = $("#count-refresh").html();
			var countL = $("#count-last").html();
			var countC = parseInt(countR) + parseInt(countL);
			$("#count-refresh").text(countC);
		}
	});

});